import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EEList } from '../time-admin/EEList';
import { TimeReport } from '../time-admin/TimeReport';
import { SummaryReport } from '../time-admin/SummaryReport';
import { Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TimeServiceService {

  private testUrl = '../../assets/data';
  // private prodUrl: string = 'https://www.cunningsloth.com/TimeEntry/AppService/';

  constructor(private http: HttpClient) { }

  getEEList(): Observable<EEList[]> {
    return this.http.get<EEList[]>(this.testUrl + '/ee.json');
  }

  getTimeReport(start: Date, end: Date): Observable<TimeReport[]> {
    return this.http.get<TimeReport[]>(this.testUrl + '/timeReport.json');
  }

  getSummaryReport(start: Date, end: Date): Observable<SummaryReport[]> {
    return this.http.get<SummaryReport[]>(this.testUrl + '/timeSummary.json');
  }

  postLogTime(eeid: number) {
    // this needs to change to a post.
    return this.http.get<SummaryReport[]>(this.testUrl + '/timeSummary.json');
  }


}
